// Base imports
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';

import {
	Configuration,
	UiNodeInputAttributes,
	SettingsFlow,
	FrontendApi,
	UpdateSettingsFlowBody,
	UpdateSettingsFlowWithPasswordMethod
} from '@ory/client';
import { AxiosError, AxiosRequestConfig } from 'axios';
import MDTextFieldWithValidation from '@/components/Validation/MDTextFieldWithValidation';
import user from '@/store/modules/user';
import { env, router, validation } from '@/_helpers';
import store from '@/store';
import notifier from '@/_helpers/notifier';
import { feApi } from '@/_helpers/ory';
import { setParam } from '@/_helpers/url';
import template from './Reset.vue';

@Component({
	mixins: [template],
	components: {
		ValidationObserver,
		MDTextFieldWithValidation
	}
})
export default class Login extends Vue {
	form: UpdateSettingsFlowWithPasswordMethod = {
		csrf_token: '',

		method: '',

		password: ''
	};

	email: string = '';

	password: string = '';

	passwordConfirmation: string = '';

	loading: boolean = false;

	passwordIsReset: boolean = false;

	get darkMode(): boolean {
		return store.state.darkMode;
	}

	flow: SettingsFlow;

	async mounted(): Promise<void> {
		this.getFlow();
	}

	async getFlow() {
		const flowID: string = this.$route.query.flow as string;
		let getNewFlowID: boolean = flowID === '' || flowID === undefined;

		await feApi
			.getSettingsFlow({ id: flowID })
			.then((response) => {
				this.setFlow(response.data);
			})
			.catch((error: AxiosError) => {
				switch (error.response?.status) {
					case 403:
						// Will only happen if the incorrect AAL is active
						// Could happen when we get SSO or MFA
						break;
					default:
						getNewFlowID = true;
				}
			});

		if (getNewFlowID) {
			feApi
				.createBrowserSettingsFlow()
				.then((response) => {
					this.setFlow(response.data);
				})
				.catch((error: AxiosError) => {
					switch (error.response.status) {
						case 403:
							// Will only happen if the incorrect AAL is active
							// Could happen when we get SSO or MFA
							break;
						default:
					}
				});
		}
	}

	setFlow(flow: SettingsFlow) {
		flow.ui.nodes.forEach((value, index, array) => {
			const node: UiNodeInputAttributes = value.attributes as UiNodeInputAttributes;
			switch (node.name) {
				case 'csrf_token':
					this.form.csrf_token = node.value;
					break;
				case 'method':
					this.form.method = node.value;
					break;
				default:
					break;
			}
		});

		setParam('flow', flow.id);
		this.flow = flow;
	}

	async add(): Promise<void> {
		if (this.loading) return;

		const isValid = await (this.$refs.form as any).validate();
		if (!isValid) {
			return;
		}

		this.loading = true;

		await feApi
			.updateSettingsFlow({ flow: this.flow.id, updateSettingsFlowBody: this.form })
			.then((response) => {
				this.setFlow(response.data);
			})
			.catch((error: AxiosError) => {
				switch (error.response.status) {
					case 400:
						// Form validation errors
						this.setFlow(error.response.data);
						break;
					case 401:
						// Invalid session token
						this.getFlow();
						this.add();
						break;
					case 403:
						// Priviliged session expired or AAL too low
						notifier.error('updating', 'password');
						break;
					default:
						notifier.error('updating', 'password');
						break;
				}
			});

		this.loading = false;
	}
}
